<div class="dialog modalWrapper">
    <div mat-dialog-title>
        <!-- <span>{{data.title}}</span> -->
        <!-- <mat-icon class="close-icon" (click)="close()">close</mat-icon> -->
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content class="content">
        <div>

            <p> Thank you for your interest in becoming a Microsoft Certified Trainer and for the time and effort you
                invested in the TEST-OUT training session. We truly appreciate your participation.</p>

            <p>After carefully reviewing your results, we regret to inform you that the required criteria were not met at
                this time. However, we are pleased to offer an alternative option to proceed. You may enroll in an
                Instructor-Led Training (ILT) session, which will provide you the opportunity to complete the
                requirements and become active.</p>
            <p><strong>Please click Continue to proceed with ILT enrolment</strong></p>

        </div>
    </div>
    <mat-divider></mat-divider>

    <div mat-dialog-actions class="footer">
        <button mat-flat-button class="continueBtn primary-color" (click)="continue()">Continue</button>
    </div>
</div>